import { Fragment } from 'react';

import { Trans, useLingui } from '@lingui/react/macro';
import { useSelector } from 'react-redux';

import { useGetDateFNSLocale } from '../../../locales/helpers';
import type { Appointment } from '../../../react-query/useAppointments';
import { parseAndFormatDate } from '../../../utils/parseDate';
import { getDisplayName } from '../helpers';
import { getPatientAge } from '../patientStrip/patientStripRedesigned/patientInfoSheet/PatientInfo';

const PrivacyFilter = () => (
  <span className="vai-text-gray-400 vai-inline vai-blur-sm">
    &#x2588;&#x2588;&#x2588;
  </span>
);

interface Props {
  appointment: Appointment;
}

export const PrivatePatientName = ({ appointment }: Props) => {
  const privacyOn = useSelector((state: any) => state.login?.user?.privacyOn);
  const { patientName, initials } = getDisplayName(appointment, 1);

  return (
    <p className="vai-typography-h4">
      {privacyOn
        ? patientName
        : initials.map((initial, index) => (
            <Fragment key={index}>
              {initial}
              <PrivacyFilter />
            </Fragment>
          ))}
    </p>
  );
};

export const PrivateDateOfBirth = ({ appointment }: Props) => {
  const { t } = useLingui();
  const dateFNSLocale = useGetDateFNSLocale();
  const privacyOn = useSelector((state: any) => state.login?.user?.privacyOn);
  const dateOfBirth = parseAndFormatDate(
    appointment.patient?.dob,
    undefined,
    dateFNSLocale,
  );

  const age = getPatientAge(appointment.patient?.dob);

  return (
    <p className="vai-typography-small">
      <Trans>Age: </Trans>
      {privacyOn ? (
        <>
          {age ?? t`Unknown`} (<Trans>DOB: </Trans>
          {dateOfBirth ? dateOfBirth : t`Unknown`})
        </>
      ) : (
        <PrivacyFilter />
      )}
    </p>
  );
};
